<template>
  <div>
    <el-form
      ref="form"
      :model="form"
      label-width="100px"
      :rules="rules"
      class="tousu"
      v-show="state1"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="姓名" prop="name">
            <el-input type="name" v-model="form.name" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系电话" prop="tel">
            <el-input type="tel" v-model="form.tel" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="被投诉人姓名">
            <el-input v-model="form.name1"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="投诉行业">
            <el-input v-model="form.industry"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="内容">
        <el-input type="textarea" v-model="form.desc"></el-input>
      </el-form-item>
      <el-form-item label="要求">
        <el-input type="textarea" v-model="form.desc1"></el-input>
      </el-form-item>
      <!-- 图片上传 -->
      <el-form-item label="图片上传">
        <el-upload
          :action="imgUploadUrl"
          :on-success="handleSuccess"
          :on-remove="handleRemove"
          multiple
          :limit="5"
          :on-exceed="handleExceed"
        >
          <el-button size="mini" type="primary">点击上传</el-button>
          <span slot="tip" class="el-upload__tip">只能上传5个jpg/png文件，且不超过500kb</span>
        </el-upload>
      </el-form-item>
      <!-- 视频上传 -->
      <el-form-item label="视频上传">
        <el-upload
          :action="videoUploadUrl"
          :on-success="handleSuccessV"
          :on-remove="handleRemove"
          multiple
          :limit="1"
          :on-exceed="handleExceed"
        >
          <el-button size="mini" type="primary">点击上传</el-button>
          <span slot="tip" class="el-upload__tip">只能上传1个文件、仅支持mp4、avi格式，且不超过20M</span>
        </el-upload>
        <el-row style="text-align:center;">
          <el-checkbox v-model="state">已阅读须知</el-checkbox>
          <el-button type="text" @click="dialogVisible = true">《须知》</el-button>
          <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
            <span>
              感谢您信任鄂尔多斯运输信息网，我们将按照“分级责任、属地管理、谁主管、谁负责，谁调查处理、谁予以答复”的原则，受理您反映的属于我们受理范围内的投诉举报事项。
              希望您署真实姓名投诉举报，对署实名的投诉举报，我们将优先受理、优先调查处理、优先予以答复，调查处理结果也将由承办部门答复您，如承办部门在调查处理完毕后仍未答复您，您可向我们反映情况。请按照要求填写您的真实手机号码，用于接收验证编码，凭该编码查询您的投诉举报办理情况。对于反映情况不实或恶意投诉者我们将保留追责权利
            </span>
          </el-dialog>
        </el-row>
        <el-row style="text-align:center;">
          <el-button type="danger" size="small" @click="postform" :disabled="disabled">确认提交</el-button>
        </el-row>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { ipconfig } from "@/assets/js/ipconfig.js";
import Axios from "axios";
export default {
  name: "ts",
  data() {
    // 此处自定义校验手机号码js逻辑
    var phoneReg = /^[1][3,4,5,7,8][0-9]{9}$/;
    var validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("号码不能为空"));
      }
      setTimeout(() => {
        if (!phoneReg.test(value)) {
          callback(new Error("格式有误"));
        } else {
          callback();
        }
      }, 10);
    };
    return {
      videoUploadUrl: `http://${ipconfig}/app/isweb/upload/uploadVideo`,//上传视频接口
      imgUploadUrl: `http://${ipconfig}/app/isweb/upload/uploadImg`,//上传图片接口
      ipconfig: "",
      disabled: true,
      dialogVisible: false,
      state: "",
      state1: true,
      fileList: [],
      img_url: "",
      img_url2: "",
      video: "",
      form: {
        industry: "",
        tel: "",
        name: "",
        name1: "",
        type: [],
        resource: "",
        desc: "",
        desc1: ""
      },
      rules: {
        name: [
          { required: true, message: "名字不能为空", trigger: "blur" },
          { min: 2, max: 6, message: "长度在 2 到 6 个字符", trigger: "blur" }
        ],
        tel: [{ required: true, validator: validatePhone, trigger: "blur" }]
      }
    };
  },
  methods: {
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    handleRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleSuccess(file, fileList) {
      this.img_url += file.data.img_url + ",";
      this.img_url2 = this.img_url.slice(0, this.img_url.length - 1);
     // debugger
    },
    handleSuccessV(file, fileList) {
       //debugger
      this.video = file.data.video_url;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    postform() {
      this.img_url;
      if (this.form.name == "" && this.form.tel == "") {
        alert("电话或名称不能为空");
        return;
      }
      let param = new URLSearchParams();
      param.append('con_name',this.form.name)
      param.append('con_type','1')
      param.append('con_telephone',this.form.tel)
      param.append('con_complained_name',this.form.name1)
      param.append('con_complained_unit',this.form.industry)
      param.append('con_complain_content',this.form.desc)
      param.append('con_complain_req',this.form.desc1)
      param.append('con_img_urls',this.img_url2)
      param.append('con_video_urls',this.video)
      Axios.post(`http://${ipconfig}/app/isweb/complain/saveComplainInfo?innerMS`,param).then(res => {
        debugger;
        this.$emit("aaa", [false, res.data.data.orderId]);
        this.state1 = false;
        this.state1 = false;
      });
    }
  },
  watch: {
    state: function() {
      if (this.state) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
      console.log(this.state);
    }
  }
};
</script>
<style scoped>
.el-button {
  margin-right: 5px;
}

.el-form {
  /* border: 1px solid red; */
  width: 80%;
  margin: 0 auto;
}
</style>


// WEBPACK FOOTER //
// src/pages/tszxsevers/ts.vue


// WEBPACK FOOTER //
// src/pages/tszxsevers/ts.vue